import * as React from "react"
import { usePage } from "@inertiajs/react"
import { Home, Inbox, Palette, Users } from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"
import type { PageProps } from "@/types/inertia"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/admin/leads",
    icon: Inbox,
    label: "Leads",
    match: (url) => url === "/admin" || url.startsWith("/admin/leads"),
  },
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  const { props } = usePage<PageProps>()

  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin/leads" />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className="mx-auto max-w-4xl">
          {props.flash.notice && <div aria-live="polite" className="callout callout-accent mb-4" role="status"><p>{props.flash.notice}</p></div>}
          {props.flash.alert && <div className="callout callout-danger mb-4" role="alert"><p>{props.flash.alert}</p></div>}
          {children}
        </div>
      </main>
    </div>
  )
}
